export enum FixturePlayByPlayEventColumns {
  EventId = "eventId",
  Class = "class",
  ClientId = "clientId",
  Clock = "clock",
  Entity = "entity",
  EntityId = "entityId",
  EventTime = "eventTime",
  EventType = "eventType",
  FixtureId = "fixtureId",
  FixtureStartTime = "fixtureStartTime",
  FixtureStatus = "fixtureStatus",
  Fixture = "fixture",
  Flagged = "flagged",
  Highlight = "highlight",
  OfficialId = "officialId",
  PeriodId = "periodId",
  Person = "person",
  PersonId = "personId",
  PlayId = "playId",
  Received = "received",
  Section = "section",
  Sequence = "sequence",
  ShotClock = "shotClock",
  Status = "status",
  SubType = "subType",
  Success = "success",
  Date = "date",
  Topic = "topic",
  Zone = "zone",
}
